import React from 'react';

import ArgoBlackIcon from '../../images/argocd-black.svg';
import ArgoIcon from '../../images/argocd.svg';

export const ArgoCDLogoSmall = () => {
  return <img height="18" src={ArgoIcon} alt="ArgoCD logo" />;
};

export const ArgoCDLogoLarge = () => {
  return <img height="32" src={ArgoIcon} alt="ArgoCD logo" />;
};

export const ArgoCDLogoMedium = () => {
  return <img height="24" src={ArgoIcon} alt="ArgoCD logo" />;
};

export const ArgoCDBlackLogo = () => {
  return <img height="18" src={ArgoBlackIcon} alt="ArgoCD logo" />;
};
